import DirectDownloadActionTypes from './types';

export const saveDownloadIds = (id) => ({
  type: DirectDownloadActionTypes.SAVE_DOWNLOAD_IDS,
  payload: id,
});

export const queryDownloadIds = (ids, allIds) => ({
  type: DirectDownloadActionTypes.QUERY_DOWNLOAD_IDS_START,
  payload: { ids, allIds },
});

export const queryDownloadIdsSuccess = () => ({
  type: DirectDownloadActionTypes.QUERY_DOWNLOAD_IDS_SUCCESS,
});

export const queryDownloadIdsFailure = (error) => ({
  type: DirectDownloadActionTypes.QUERY_DOWNLOAD_IDS_FAILED,
  payload: error,
});

export const updateDownloadIds = (ids) => ({
  type: DirectDownloadActionTypes.UPDATE_DOWNLOAD_IDS,
  payload: ids,
});
